// Shared "which one is active" styling for both levels of navigation in
// this feature (the top-level Loans/Funders/Audit Log nav, and the inner
// Allocations/Audit toggle on a detail page) - a pill-shaped background on
// the active item reads much more clearly than a thin underline alone.
const navItemStyle = (isActive) => ({
    textDecoration: "none",
    display: "inline-block",
    padding: "6px 16px",
    borderRadius: "999px",
    fontWeight: isActive ? 700 : 500,
    fontFamily: "inherit",
    fontSize: "inherit",
    color: isActive ? "#fff" : "rgba(255,255,255,0.6)",
    background: isActive ? "#2a2f5c" : "transparent",
    cursor: "pointer",
    border: "none",
});

export { navItemStyle };
